const events = [
  { num: 'No. 01', icon: '✦', title: 'The Gala Ball', desc: 'An evening of glamour, music, dinner and dancing — the centrepiece of our anniversary year, bringing every generation together under one roof.', when: 'Autumn 2026' },
  { num: 'No. 02', icon: '†', title: 'Anniversary Mass', desc: 'A series of celebratory Masses giving thanks for fifty years — for our founders, teachers, families and the pupils we have lost along the way.', when: 'Throughout the Year' },
  { num: 'No. 03', icon: '❦', title: 'Open Community Days', desc: 'Walk the corridors again. Sit at the old desks. Bring your children to see where it all started — community events held on school grounds.', when: 'Spring 2027' },
  { num: 'No. 04', icon: '◈', title: 'Fundraising Initiatives', desc: 'Give back to the school that gave so much. Sponsored events, legacy gifts and class-year challenges to fund the next fifty years.', when: 'Year-round' },
];

export default function Events() {
  return (
    <section className="events" id="events" style={{
      background: 'var(--navy-deep)', color: 'var(--cream)',
      paddingTop: '8rem', paddingBottom: '8rem', position: 'relative',
    }}>
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: 'radial-gradient(circle at 70% 30%, rgba(201, 164, 76, 0.08) 0%, transparent 50%)',
        pointerEvents: 'none',
      }} />
      <div className="events-header" style={{
        maxWidth: 1300, margin: '0 auto 4rem',
        display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem', alignItems: 'end',
      }}>
        <div>
          <div className="section-eyebrow" style={{
            color: 'var(--gold)', fontSize: '0.75rem',
            letterSpacing: '0.4em', textTransform: 'uppercase',
            marginBottom: '1rem', fontWeight: 500,
            display: 'flex', alignItems: 'center', gap: '0.8rem',
          }}>
            <span style={{ width: 30, height: 1, background: 'var(--gold)' }} />
            The Year Ahead
          </div>
          <h2 className="section-title" style={{
            fontFamily: "'Fraunces', serif", fontWeight: 400,
            fontSize: 'clamp(2rem, 4vw, 3.2rem)', lineHeight: 1.1,
            color: 'var(--cream)', marginBottom: '1.5rem', letterSpacing: '-0.01em',
          }}>A calendar of <em style={{ fontStyle: 'italic', color: 'var(--gold)' }}>celebration.</em></h2>
        </div>
        <p style={{
          fontFamily: "'Cormorant Garamond', serif", fontSize: '1.2rem',
          fontStyle: 'italic', color: 'rgba(246, 241, 230, 0.75)', lineHeight: 1.6,
        }}>
          Throughout the 2026/2027 academic year, our school, our parish and our wider community will come together for a series of events — gatherings of faith, festivity and fundraising, open to past pupils, present families and neighbours alike. Register below to be the first to hear when tickets and dates are released.
        </p>
      </div>

      <div className="events-grid" style={{
        maxWidth: 1300, margin: '0 auto',
        display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1.5rem',
      }}>
        {events.map((ev, i) => (
          <article key={i} className="event-card" style={{
            border: '1px solid rgba(201, 164, 76, 0.25)',
            padding: '2rem 1.6rem', position: 'relative',
            background: 'rgba(255, 255, 255, 0.02)',
            transition: 'all 0.4s', cursor: 'pointer',
            minHeight: 320, display: 'flex', flexDirection: 'column',
          }}>
            <div className="event-num" style={{
              fontFamily: "'Fraunces', serif", fontStyle: 'italic',
              color: 'var(--gold)', fontSize: '0.9rem', marginBottom: '1.5rem', opacity: 0.7,
            }}>{ev.num}</div>
            <div className="event-icon" style={{
              fontFamily: "'Fraunces', serif", fontSize: '2.2rem',
              color: 'var(--gold)', marginBottom: '1rem', fontStyle: 'italic',
            }}>{ev.icon}</div>
            <h3 style={{
              fontFamily: "'Fraunces', serif", fontWeight: 500,
              fontSize: '1.5rem', marginBottom: '0.8rem', color: 'var(--cream)',
            }}>{ev.title}</h3>
            <p style={{
              fontSize: '0.92rem', color: 'rgba(246, 241, 230, 0.7)',
              lineHeight: 1.55, marginBottom: '1.2rem', flex: 1,
            }}>{ev.desc}</p>
            <div className="event-when" style={{
              fontSize: '0.72rem', letterSpacing: '0.2em',
              textTransform: 'uppercase', color: 'var(--gold)',
              paddingTop: '1rem', borderTop: '1px solid rgba(201, 164, 76, 0.2)',
            }}>{ev.when}</div>
          </article>
        ))}
      </div>

      <style jsx>{`
        .event-card:hover {
          background: rgba(201, 164, 76, 0.06) !important;
          border-color: var(--gold) !important;
          transform: translateY(-4px);
        }
        @media (max-width: 960px) {
          .events-header { grid-template-columns: 1fr !important; gap: 2rem !important; }
          .events-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 560px) {
          .events-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
